import Pokegame from './Pokegame'
import './Pokecard.css'
import './App.css'

function App() {
  return (
    <div className='App'>
      <h1>Pokemon Go Card Game</h1>
      <Pokegame />
    </div>
  )
}

export default App